import React, { memo } from 'react'
import { useCallback } from 'sb-hooks'
import { Field, useFieldState } from 'formular'
import type { Moment } from 'moment'

import { SelectableOptionView } from 'components/_new/controls'
import { Row } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


export type SkipOptionProps = {
  field: Field<number>
  monthCount: number
  restartDate: Moment
}

const SkipOption: React.FunctionComponent<SkipOptionProps> = ({ field, monthCount, restartDate }) => {
  const { value } = useFieldState(field)
  const checked = value === monthCount

  const handleClick = useCallback(() => {
    field.set(monthCount)
  }, [ field, monthCount ])

  return (
    <SelectableOptionView type="radio" checked={checked} onClick={handleClick} dataTestId="skipAMonthOption">
      <Row justify="between" align="start">
        <Text
          size="16-24"
          message={{ ...messages.monthCount, values: { count: monthCount } }}
        />
        <Text
          size="14-24"
          color="gray-50"
          message={{ ...messages.restartDate, values: { date: restartDate.format('MMM D') } }}
        />
      </Row>
    </SelectableOptionView>
  )
}


export default memo(SkipOption)
